<script>
	// The params prop contains values matched from the URL
	export let params = {};

	import {createEventDispatcher, onDestroy, onMount} from 'svelte';
	import {location, replace} from 'svelte-spa-router';
	import {
		API,
		cabecalhoPadraoRequisicao,
		convertHMS,
		gerarStringAleatoria,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';
	import {sCaptcha} from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let senha, anotacoes, captchaUsuario;

	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let timerAvaliacao;
	let segundosAcumuladosLS;
	let parseAfirmacoes = [];
	let objetoAvaliado = {};
	let lsObjetoAvaliado;
	let dataInicialAvaliacao = "";
	let dataFinalAvaliacao = "";
	let informacosAPICache;
	let avaliacaoIniciada;

	onMount(async () => {
		lsObjetoAvaliado = `AVAL_TIMER_AVALICAO_${params.idObjetoAvaliado}`;

		segundosAcumuladosLS = JSON.parse(localStorage.getItem(lsObjetoAvaliado))?.segundos ?? 1;
		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		dataInicialAvaliacao = informacosAPICache.prazos?.avaliacao_inicio ?? '[#Erro - necessário limpar cache]';
		dataFinalAvaliacao = informacosAPICache.prazos?.avaliacao_fim ?? '[#Erro - necessário limpar cache]';
		
		if (verificarSessionStorage('AVAL_TOKEN')) {
			timerAvaliacao = setInterval(LSTimer, 1000);

			avaliacaoIniciada = await recuperarAvaliacaoIniciada(params.idAvaliacao);
			objetoAvaliado = avaliacaoIniciada.objetoAvaliado;

			if (avaliacaoIniciada.objetoAvaliadoEProjeto == true) {
				carregarAfirmacoesAPI(objetoAvaliado.modalidade_const);
			} else {
				carregarAfirmacoesAPI('APRESENTACAO_SEMANA_GRADUACAO');
			}
		} else replace("/login");
	});

	// se a rota sofrer alteração e outro componente for montado, pausar o timer
	onDestroy(async () => {
		clearInterval(timerAvaliacao);
	});

	const recuperarAvaliacaoIniciada = async (idAvaliacao) => {
		const resposta = await fetch(API(`avaliacoes/${idAvaliacao}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});
			
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			replace("#/painel");
		});
		
		const { dados } = await resposta.json();

		if (resposta.status == StatusHttp.OK)
			return dados;
		else
			replace('#/painel')
	}

	const recuperarValoresSelecionadosItens = () => {
		let postItensAvaliados = [];
		let inputsSelect = document.getElementsByTagName('select');
		let spreadInputs;
		
		spreadInputs = [...inputsSelect];
		spreadInputs.filter(item => postItensAvaliados.push([item.name, item.value]));

		return postItensAvaliados;
	}

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Enviando os dados ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			let valoresSelectArray = recuperarValoresSelecionadosItens();

			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('avaliacao'), {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					avaliacao: params.idAvaliacao,
					valoresSelecionados: valoresSelectArray,
					anotacoes: anotacoes,
					senha: senha,
					duracao: convertHMS(segundosAcumuladosLS)
				})
			}).catch(erros => {
				console.log(erros);

				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.OK) {		
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: 'Avaliação finalizada com sucesso.'
				});

				localStorage.removeItem(lsObjetoAvaliado);

				setTimeout( () => replace('#/painel'), 300);
			} else {
				feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}

	}

	const LSTimer = () => {
		localStorage.setItem(lsObjetoAvaliado, JSON.stringify({
			segundos: segundosAcumuladosLS += 1,
		}));
	}

	// toda vez que a página perder o foco, pausa o timer
	if ($location.startsWith('/avaliacao/preencher-formulario-avaliacao')) {
		document.addEventListener("visibilitychange", (evento) => {
			
			if (document.visibilityState === 'visible')
				timerAvaliacao = setInterval(LSTimer, 1000);
			else
				clearInterval(timerAvaliacao);
		});
	}

	const carregarAfirmacoesAPI = async (tipoFormulario) => {

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});

		const resposta = await fetch(API(`afirmacoes-por-tipo-formulario/${tipoFormulario}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const { dados } = await resposta.json();

		if (resposta.status == StatusHttp.OK) {


			// se objeto avaliado for projeto buscar pela modalidade, caso contrário pela flag de apresentação semana graduacao



			parseAfirmacoes = [...Object.values(dados)];
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: dados?.mensagem
			});
			
			replace("/login");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<style>
	.borda-1 {
		border: 1px solid #aaa;
	}	
</style>

<TBox 
	titulo="Formulário de Avaliação" 
	subtitulo="Utilize os campos abaixo para avaliar o projeto ou apresentação" 
	largura="12" 
	deslocamento="0"
	icone="avaliacao">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		{#if avaliacaoIniciada?.objetoAvaliadoEProjeto == true}
		<a href="#/projeto/visualizar/anonimizado/{window.btoa(objetoAvaliado?.codigo.split('').reverse().join(''))}/{avaliacaoIniciada?.id}" title="Ver projeto"><span class="tag borda-1">👁️ Ver</span></a>
		<span class="tag is-black">📌 Projeto em avaliação: {objetoAvaliado?.titulo ?? 'carregando...'} </span>
		{:else}
		<a href="#/apresentacao/visualizar/{objetoAvaliado?.id}/{objetoAvaliado?.projeto?.codigo}" title="Ver apresentação"><span class="tag borda-1">👁️ Ver</span></a>
		<span class="tag is-black">📌 Apresentação em avaliação: {objetoAvaliado?.projeto?.titulo ?? 'carregando...'} </span>
		{/if}
		
		<span class="tag is-primary is-pulled-right" title="Duração da avaliação">🕒 {convertHMS(segundosAcumuladosLS)}</span>

		<br>

		<div class="notification is-danger is-light mt-2">
			<p>{`Prazo para avaliação de ${objetoAvaliado?.objetoAvaliadoEProjeto == true ? 'projetos' : 'apresentações'}`}: de <strong>{dataInicialAvaliacao}</strong> até <strong>{dataFinalAvaliacao}</strong>.</p>
		</div>
		
		<p class="mt-1">Leia atentamente cada afirmação e selecione ao lado uma opção para avaliar.</p>

		<hr>

		<div class="columns">
			<div class="column">
				<p class="is-size-4">Avalie os itens abaixo:</p>
				<p class="is-size-6 is-italic mb-3">Escolha um nível de concordância/discordância para avaliar o item.</p>

				<table class="table is-hoverable is-striped">
					{#each parseAfirmacoes as afirmacao, indice}
					<tr>
						<td class="has-text-primary">{++indice}</td>
						<td class="is-size-5">{afirmacao.titulo}</td>
						<td>
							<div class="select is-primary is-large is-fullwidth">
								<select name="item_{afirmacao.id}" required>
									<option value="">Avalie...</option>
									<option value="1">Discordo totalmente</option>
									<option value="2">Discordo parcialmente</option>
									<option value="3">Não discordo nem concordo</option>
									<option value="4">Concordo parcialmente</option>
									<option value="5">Concordo totalmente</option>
								</select>
							</div>
						</td>
					</tr>
					{/each}
				</table>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p title="Apenas de carater informativo ou de feedback, não é utilizado para pontuar o projeto avaliado.">Anotações: </p>
				<textarea bind:value={anotacoes} class="textarea" placeholder="Se desejar informar alguma observação sobre a avaliação ou o projeto, digite aqui." rows="5"></textarea>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="mb-3">Para finalizar a avaliação, informe sua senha e o captcha abaixo e clique em "Finalizar". Esta operação é definitiva, uma vez finalizada uma avaliação não será mais possível editar as avaliações aferidas nos ítens do formulário.</p>
			</div>
		</div>

		<div class="columns">
			<div class="column is-4">
				<div class="field">
					<input 
						bind:value={senha}
						name="senha" 
						type="password" 
						placeholder="Informe sua senha" 
						class="input is-large is-primary" required>
				</div>
			</div>
			<div class="column is-4">
				<Captcha />
			</div>
			<div class="column is-4">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Finalizar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>